import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

import { useLocales } from 'src/locales';
import { Iconify } from 'src/components/iconify';
import type { XlsxWorkbookSpec } from 'src/utils/file-downloader';

import { useStatsExport } from './use-stats-export';

type Props = {
  build: () => Promise<XlsxWorkbookSpec | null>;
  disabled?: boolean;
};

/** NAT-2481 — «Esporta XLSX» on a BI stats table: the list views' label and icon, as a button. */
export function StatsExportButton({ build, disabled }: Props) {
  const { t } = useLocales();
  const { exporting, run } = useStatsExport(build);
  return (
    <Button
      size="small"
      color="inherit"
      variant="outlined"
      onClick={run}
      disabled={disabled || exporting}
      data-testid="stats-export-button"
      startIcon={exporting ? <CircularProgress size={16} /> : <Iconify icon="solar:export-bold" />}
    >
      {`${t('export')} XLSX`}
    </Button>
  );
}
